"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-textstyle"
  }, [_c('div', {
    staticClass: "kiwi-textstyle-row"
  }, [_c('button', {
    staticClass: "kiwi-textstyle-button",
    class: {
      'kiwi-textstyle-button--active': _vm.activeFormats.bold
    },
    attrs: {
      "type": "button",
      "title": "Bold"
    },
    on: {
      "mousedown": function mousedown($event) {
        $event.preventDefault();
      },
      "click": _vm.toggleBold
    }
  }, [_c('i', {
    staticClass: "fa fa-bold",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('button', {
    staticClass: "kiwi-textstyle-button",
    class: {
      'kiwi-textstyle-button--active': _vm.activeFormats.italic
    },
    attrs: {
      "type": "button",
      "title": "Italic"
    },
    on: {
      "mousedown": function mousedown($event) {
        $event.preventDefault();
      },
      "click": _vm.toggleItalic
    }
  }, [_c('i', {
    staticClass: "fa fa-italic",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('button', {
    staticClass: "kiwi-textstyle-button",
    class: {
      'kiwi-textstyle-button--active': _vm.activeFormats.underline
    },
    attrs: {
      "type": "button",
      "title": "Underline"
    },
    on: {
      "mousedown": function mousedown($event) {
        $event.preventDefault();
      },
      "click": _vm.toggleUnderline
    }
  }, [_c('i', {
    staticClass: "fa fa-underline",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('button', {
    staticClass: "kiwi-textstyle-button",
    class: {
      'kiwi-textstyle-button--active': _vm.activeFormats.strikethrough
    },
    attrs: {
      "type": "button",
      "title": "Strikethrough (Ctrl+E)"
    },
    on: {
      "mousedown": function mousedown($event) {
        $event.preventDefault();
      },
      "click": _vm.toggleStrikethrough
    }
  }, [_c('i', {
    staticClass: "fa fa-strikethrough",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('span', {
    staticClass: "kiwi-textstyle-divider"
  }), _c('span', {
    staticClass: "kiwi-textstyle-label"
  }, [_vm._v("FG")]), _c('div', {
    staticClass: "kiwi-textstyle-colours"
  }, _vm._l(_vm.colours, function (colour, idx) {
    return _c('div', {
      key: "fg-".concat(idx),
      staticClass: "kiwi-textstyle-colour",
      class: {
        'kiwi-textstyle-colour--active': _vm.activeFormats.fgColour === idx
      },
      style: {
        'background-color': colour
      },
      attrs: {
        "title": "Foreground colour ".concat(idx)
      },
      on: {
        "mousedown": function mousedown($event) {
          $event.preventDefault();
        },
        "click": function click($event) {
          return _vm.setColour(idx);
        }
      }
    });
  }), 0), _c('span', {
    staticClass: "kiwi-textstyle-divider"
  }), _c('span', {
    staticClass: "kiwi-textstyle-label"
  }, [_vm._v("BG")]), _c('div', {
    staticClass: "kiwi-textstyle-colours"
  }, _vm._l(_vm.colours, function (colour, idx) {
    return _c('div', {
      key: "bg-".concat(idx),
      staticClass: "kiwi-textstyle-colour kiwi-textstyle-colour--bg",
      class: {
        'kiwi-textstyle-colour--active': _vm.activeFormats.bgColour === idx
      },
      style: {
        'background-color': colour
      },
      attrs: {
        "title": "Background colour ".concat(idx)
      },
      on: {
        "mousedown": function mousedown($event) {
          $event.preventDefault();
        },
        "click": function click($event) {
          return _vm.setBgColour(idx);
        }
      }
    });
  }), 0), _c('span', {
    staticClass: "kiwi-textstyle-divider"
  }), _c('button', {
    staticClass: "kiwi-textstyle-button kiwi-textstyle-button--reset",
    attrs: {
      "type": "button",
      "title": "Reset all styles"
    },
    on: {
      "mousedown": function mousedown($event) {
        $event.preventDefault();
      },
      "click": _vm.resetStyle
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]);
};
var staticRenderFns = exports.staticRenderFns = [];